export default class TestPlanState {
  constructor() {
    // GET Test Plan
    this.testPlan = {
      loading: false,
      data: {},
      error: null,
    };

    // GET Test Plan options
    this.testPlanOptions = {
      loading: false,
      data: [],
      error: null,
    };

    // GET Test Plan products
    this.testPlanProducts = {
      loading: false,
      data: [],
      error: null,
    };

    // POST Test Plan product request
    this.testPlanProductRequest = {
      loading: false,
      data: {},
      error: null,
    };

    // POST Test Plan subscription
    this.testPlanSubscription = {
      loading: false,
      data: {},
      error: null,
    };

    // DOWNLOAD Test Plan PDF
    this.testPlanPdf = {
      loading: false,
      data: null,
      error: null,
    };
  }
}
